import React from "react";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import { FluentTabList } from "../../../../components/FluentUI/Fluent-TabList";
import FluentBreadcrumb from "../../../../components/FluentUI/Fluent-Breadcrumb";
import { FluentButton } from "../../../../components/FluentUI/Fluent-Button";
import FluentUiIcon from "../../../../assets/fluent-ui-icon";
import { PrepareBreadCrumbList, tabList, SelectedTabContent } from "./subdepartment-util";

const SubDepartmentLayout = ({
  subDepartment,
  setSubDepartment,
  selectedValue,
  setSelectedValue,
  isSubmitting,
  handleSave,
  handleCancel,
  errors,
  setErrors,
  isEdit,
}) => {
  const history = useHistory();

  return (
    <div className="sub-department-container">
      <div className="sub-department-left-panel">
        <div
          className="sub-department-left-panel-back"
          onClick={() => history.push("/admin?tab=organization&subtab=subdepartments")}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              history.push("/admin?tab=organization&subtab=subdepartments");
            }
          }}
          role="button"
          tabIndex="0"
        >
          <FluentUiIcon name={"ArrowLeftRegular"} color={"#0F6CBD"} size={20} />
          <span className="pl-2">Back to Organization</span>
        </div>

        <FluentTabList
          tabList={tabList}
          tabClick={(selection) => setSelectedValue(selection)}
          currentTab={selectedValue}
        />
      </div>

      <div className="sub-department-content">
        <div className="sub-department-content-header">
          <FluentBreadcrumb
            breadcrumbs={PrepareBreadCrumbList(subDepartment, selectedValue)}
          />
        </div>

        <div className="sub-department-content-form">
          {SelectedTabContent(selectedValue, subDepartment, setSubDepartment, errors, setErrors)}
        </div>

        <div className="sub-department-content-footer" data-testid="fluent-cancel-button">
          <FluentButton
            onClick={handleCancel}
            text={"Cancel"}
            backgroundColor={"#0F6CBD"}
            disabled={isSubmitting}
          />
          <div className="sub-department-content-footer-button" data-testid={isEdit ? "fluent-save-button" : "fluent-create-button"}>
            <FluentButton
              onClick={handleSave}
              appearance="primary"
              text={isEdit ? "Save" : "Create"}
              backgroundColor={"#0F6CBD"}
              disabled={isSubmitting}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubDepartmentLayout;

SubDepartmentLayout.propTypes = {
  subDepartment: PropTypes.shape({
    Name: PropTypes.string.isRequired,
    Departments: PropTypes.array.isRequired,
    allDepartments: PropTypes.array.isRequired,
    allTaskTypes: PropTypes.array.isRequired,
    allProjectTemplates: PropTypes.array.isRequired,
    DefaultProjectTemplate: PropTypes.shape({
      Id: PropTypes.number,
      ProjectType: PropTypes.string,
    }),
    DefaultTaskType: PropTypes.shape({
      Id: PropTypes.number,
      Type: PropTypes.string,
    }),
    Active: PropTypes.bool.isRequired,
  }).isRequired,
  setSubDepartment: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  handleSave: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  setErrors: PropTypes.func.isRequired,
  isEdit: PropTypes.bool.isRequired,
  selectedValue: PropTypes.string.isRequired,
  setSelectedValue: PropTypes.func.isRequired,
};
